import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Heading } from 'rebass';

const fontSize = ({ level, f }) => !f ? `font-size: ${1.3 + (2 * (1 / level))}rem;` : null;

const styles = css`
  line-height: 1.15;
  font-weight: bold;
  color: inherit;
  ${fontSize}
`;

const GlowHeading = styled(({ level, ...props }) => (
  <Heading is={`h${level}`} {...props} />
))`${styles}`;

GlowHeading.propTypes = {
  level: PropTypes.number,
};
GlowHeading.defaultProps = {
  level: 1,
};

export default GlowHeading;



// WEBPACK FOOTER //
// ./src/components/Atoms/GlowHeading/index.js